import { Account, UserWorkspace } from "@/types/auth";
import { ACCOUNT, WORKSPACES } from "./types";
import { getUser, getUserWorkspaces } from "./requests";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getWorkspace } from "@/helpers/auth";

export const useAccount = () =>
  useQuery<Account>({ queryKey: ACCOUNT, queryFn: getUser });

export const useWorkspaces = () =>
  useQuery<UserWorkspace[]>({
    queryKey: WORKSPACES,
    queryFn: getUserWorkspaces,
  });

export const useWorkspace = () => {
  const workspaceId = getWorkspace();
  const { data: workspaces, isFetching } = useWorkspaces();
  const memoizedWorkspace = useMemo(() => {
    return workspaces?.find((uw) => uw.workspace.id.toString() === workspaceId)
      ?.workspace;
  }, [workspaces, workspaceId, isFetching]);
  return memoizedWorkspace;
};
